import React from 'react'
import { array, func, string } from 'prop-types'

import SmartLink from '@/component/Primitive/SmartLink'
import Type from '@/component/Primitive/Type'
import Icon from '@/component/Primitive/Icon'

import styles from './NavigationDropdown.module.scss'

const NavigationDropdown = ({ items, onClick, closeNav, baseUrl }) => {
  const itemTypeMap = {
    section: 'section',
    eventSection: 'events'
  }

  const getHref = (item) => {
    if (item.type === 'externalLink') return item.url
    if (baseUrl) {
      return `${baseUrl}/${item.url}`
    }
    return item.url
  }

  return (
    <div className={styles.NavigationDropdown}>
      <div className={styles.NavigationDropdownInner}>
        {items.map((item, i) => (
          <SmartLink
            target={!item.type && '_blank'}
            href={item.type && getHref(item)}
            to={item.type && `/${itemTypeMap[item.type]}`}
            onClick={(e) => {
              if (closeNav) {
                closeNav()
              }
              if (onClick) {
                e.preventDefault()
                onClick(item)
              }
            }}
            className={styles.NavigationDropdownItem}
            key={i}
          >
            <Type
              themed
              weight={['medium', 'regular']}
              size={['heading7', 'body4']}
            >
              {item.icon && (
                <Icon type={item.icon} width={18} className={styles.Icon} />
              )}
              {item.title || item.text}
            </Type>
          </SmartLink>
        ))}
      </div>
    </div>
  )
}

NavigationDropdown.propTypes = {
  items: array,
  onClick: func,
  closeNav: func,
  baseUrl: string
}

export default NavigationDropdown
